import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button, Dialog, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr, roleInfo, ADD } from '../../../common/common';
import { getObjByName, getToday } from '../../../common/utils';
import Toast from '../../Layout/components/Toast';
import AlertDialog from '../../Layout/components/AlertDialog'
import AddMatter from '../../Timesheet/components/AddMatter';
import LevelChoose from '../../Components/LevelChoose';
import CaseAutoComplete from '../../Components/CaseAutoComplete';

const Root = styled(Box)({
    width: '100%',
    height: '100%',
    '& .wapperL': {
        width: '30%',
        height: '100%',
        backgroundColor: '#F6F6F6',
        padding: '20px',
        '& .timerWapper': {
            width: '100%',
            '& .timer': {
                padding: '5px 20px',
                borderRadius: '3px',
                color: '#fff',
                background: 'linear-gradient(180deg,rgba(180,236,81,1) 0%,rgba(66,147,33,1) 100%)',
                '& .timerNum': {
                    width: '100%',
                    '& .num': {
                        fontSize: '64px',
                        lineHeight: '64px',
                    },
                    '& .circle': {
                        width: '5px',
                        height: '5px',
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                        margin: '5px 13px',
                    },
                },
                '& .timerText': {
                    width: '100%',
                    '& .text': {
                        fontSize: '10px',
                    },
                    '& .textM': {
                        fontSize: '10px',
                        margin: '0 57px',
                    },
                },
            },
            '& .btnWapper': {
                marginTop: '34px',
                '& .timerBtn': {
                    width: '120px',
                    margin: '0 12px',
                    backgroundColor: '#fff',
                },
            },
        },
    },
    '& .wapperR': {
        width: '70%',
        height: '100%',
        padding: '20px',
        '& .infoL': {
            marginRight: '70px',
        },
        '& .createBtn': {
            marginTop: '20px',
        },
    },
    '& .infoL': {
        width: '30%',
    },
    '& .infoR': {
        width: '70%',
        '& .create': {
            color: '#009CEE',
            cursor: 'pointer',
            marginBottom: '10px',
            userSelect: 'none',
        },
        '& .create:hover': {
            opacity: '0.7',
        },
    },
    '& .item': {
        width: '100%',
        '& .itemL': {
            width: '60%',
            marginRight: '10px',
        },
        '& .itemS': {
            width: '40%',
        },
    },
    '& .dateField': {
        width: '100%',
        marginTop: '16px',
        marginBottom: '8px',
    },
    '& .textField': {
        width: '100%',
    },
    '& .textField-half': {
        width: '50%',
    },
    '& .title1': {
        color: '#0060A0',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    '& .title2': {
        color: '#142D33',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12'
    },
    '& .mr-20': {
        marginRight: '10px'
    },
})

const START = "start";
const STOP = "stop";
const RESET = "reset";
const CONTINUE = "continue";
const HASMATTER = 'has';
const NOMATTER = 'no';

class Timer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogTitle: "",
            dialogState: ADD,
            count: 0,
            date: getToday(),
            matter_id: "",
            mattersData: [],
            note: "",
            timerState: START,
            timeS: "00",
            timeM: "00",
            timeH: "00",
            hours_type: "",
            hourTypeData: ['Billable', 'Admin', 'Billing', 'Research'],
            hours: 0,
            radioValue: HASMATTER,
            caseObj: null,

            handler_id: "",
            handler_team_id: "",
            handler_department_id: "",

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleTimerClick = this.handleTimerClick.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.showNum = this.showNum.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCreateMatter = this.handleCreateMatter.bind(this);
        this.handleCreateTimesheet = this.handleCreateTimesheet.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.updateCaseObj = this.updateCaseObj.bind(this);
    }

    render() {
        const {
            open,
            radioValue,
            dialogTitle,
            dialogState,
            timerState,
            date,
            matter_id,
            mattersData,
            note,
            timeS,
            timeM,
            timeH,
            hours_type,
            hourTypeData,
            hours,
            caseObj,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;
        const matterView = () => {
            if (radioValue === HASMATTER) {
                return <div>
                    <div className="title2">Choose an Existing Matter</div>
                    <div className="h">
                        <div className="textField-half mr-20">
                            <CaseAutoComplete
                                initCase={caseObj}
                                update={this.updateCaseObj}
                            />
                        </div>
                        {chooseMatter()}
                    </div>
                    <Button size="small" disabled={radioValue === NOMATTER} color="primary"
                        onClick={this.handleCreateMatter}>+ Create a New Matter</Button>
                </div>
            } else {
                return <div>
                    <div className="title2">Choose a Team</div>
                    <LevelChoose
                        ref={(child) => { this.levelChoose = child }}
                        justTeam={true}
                    />
                </div>
            }
        }
        const chooseMatter = () => {
            if (mattersData) {
                if (mattersData.length > 0) {
                    return <TextField
                        margin="dense"
                        variant="outlined"
                        className="textField-half"
                        value={matter_id}
                        select
                        onChange={e => this.handleChange(e, 'matter_id')}
                    >
                        {mattersData.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.number} / {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                }
            }
            if (caseObj) {
                return <TextField
                    margin="dense"
                    variant="outlined"
                    className="textField-half"
                    value={"No matters"}
                    disabled={true}
                />
            }
        }
        const timerBtn = () => {
            if (timerState === START) {
                return <Button
                    className="timerBtn"
                    variant="outlined"
                    color="primary"
                    onClick={e => this.handleTimerClick(e, START, STOP)}
                >
                    START
                </Button>
            } else if (timerState === STOP) {
                return <Button
                    className="timerBtn"
                    variant="outlined"
                    color="secondary"
                    onClick={e => this.handleTimerClick(e, STOP, CONTINUE)}
                >
                    STOP
                </Button>
            } else if (timerState === CONTINUE) {
                return <Button
                    className="timerBtn"
                    variant="outlined"
                    color="primary"
                    onClick={e => this.handleTimerClick(e, CONTINUE, STOP)}
                >
                    CONTINUE
                </Button>
            }
        }
        return (
            <Root className="h">
                <div className="wapperL v v-c">
                    <div className="title1">MY TIMER</div>
                    <div className="line"></div>
                    <div className="timerWapper c f">
                        <div className="timer v">
                            <div className="timerNum h h-c">
                                <div className="num">{timeH}</div>
                                <div className="c">
                                    <div className="circle"></div>
                                    <div className="circle"></div>
                                </div>
                                <div className="num">{timeM}</div>
                                <div className="c">
                                    <div className="circle"></div>
                                    <div className="circle"></div>
                                </div>
                                <div className="num">{timeS}</div>
                            </div>
                            <div className="timerText h">
                                <div className="text f c">hour</div>
                                <div className="textM c">min</div>
                                <div className="text f c">sec</div>
                            </div>
                        </div>
                        <div className="btnWapper h">
                            <Button
                                disabled={timerState === STOP || timerState === START}
                                className="timerBtn"
                                variant="outlined"
                                onClick={e => this.handleTimerClick(e, RESET, START)}
                            >
                                RESET
                            </Button>
                            {timerBtn()}
                        </div>
                    </div>
                </div>
                <div className="wapperR">
                    <div className="title1">QUICK CREATE</div>
                    <div className="line"></div>
                    <div className="h h-t">
                        <div className="infoL v v-t">
                            <div className="item">
                                <div className="title2">Select Date</div>
                                <TextField
                                    id="date"
                                    type="date"
                                    variant="outlined"
                                    className="dateField"
                                    value={date}
                                    margin="dense"
                                    onChange={e => this.handleChange(e, 'date')}
                                    style={{ marginTop: 8 }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className="item h">
                                <div className="itemL">
                                    <div className="title2">Select Task Type</div>
                                    <TextField
                                        id="hourtype"
                                        select
                                        className="textField"
                                        value={hours_type}
                                        onChange={e => this.handleChange(e, "hours_type")}
                                        margin="dense"
                                        variant="outlined"
                                    >
                                        {hourTypeData.map((name, index) => (
                                            <MenuItem key={index} value={name}>
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                                <div className="itemS">
                                    <div className="title2">Total Hours</div>
                                    <TextField
                                        id="outlined-select-currency"
                                        className="textField"
                                        value={hours}
                                        onChange={e => this.handleChange(e, 'hours')}
                                        margin="dense"
                                        variant="outlined"
                                        type="number"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="infoR v v-t">
                            <div className="item">
                                <RadioGroup
                                    aria-label="Gender"
                                    name="gender1"
                                    row
                                    value={radioValue}
                                    onChange={this.handleRadio}
                                >
                                    <FormControlLabel value={HASMATTER} control={<Radio color="primary" />}
                                        label="Matter" />
                                    <FormControlLabel value={NOMATTER} control={<Radio color="primary" />}
                                        label="No Matter" />
                                </RadioGroup>
                                {matterView()}
                            </div>
                            <div className="item">
                                <div className="title2">Note</div>
                                <TextField
                                    id="outlined-multiline-static"
                                    margin="dense"
                                    variant="outlined"
                                    className="textField"
                                    multiline
                                    rows="3"
                                    value={note}
                                    onChange={e => this.handleChange(e, 'note')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="v v-r">
                        <Button className="createBtn" variant="contained" color="primary"
                            onClick={this.handleCreateTimesheet}>GENERATE TIMESHEET</Button>
                    </div>
                </div>
                <Dialog maxWidth={false} open={open}>
                    <AddMatter
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        state={dialogState}
                    ></AddMatter>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to use this length of time on your timesheet?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        )
    }

    componentDidMount() {
        // this.getMatters();
        // if (roleName !== ADMIN) {
        //     userDao.getUserInfo((userData) => {
        //         console.log(userData)
        //         const team = userData.teams ? userData.teams[0] : "";
        //         const handler_id = userData.id;
        //         const handler_team_id = team ? team.id : "";
        //         const handler_department_id = team ? team.dept.id : "";
        //         this.setState(() => ({
        //             handler_id,
        //             handler_team_id,
        //             handler_department_id,
        //         }));
        //         console.log("userdata======", userData, handler_id, handler_team_id, handler_department_id)
        //     })
        // }
    }

    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleTimerClick(e, name, value) {
        if (name === START) {
            this.startTimer();
        } else if (name === STOP) {
            clearInterval(this.timer);
            this.setState(() => ({
                showAlert: true
            }))
        } else if (name === CONTINUE) {
            this.startTimer();
        } else if (name === RESET) {
            clearInterval(this.timer);
            this.setState(() => ({
                count: 0,
                timeS: "00",
                timeM: "00",
                timeH: "00",
            }))
        }
        this.setState(() => ({
            timerState: value
        }))
    }

    updateCaseObj(caseObj) {
        if (caseObj) {
            const mattersData = caseObj.matters;
            this.setState(() => ({
                caseObj,
                mattersData,
                matter_id: ""
            }))
        }
    }

    handleCreateMatter() {
        this.openDialog("CREATE A NEW MATTER", ADD);
    }

    handleCreateTimesheet() {
        const {
            radioValue,
            mattersData,
            date,
            matter_id,
            note,
            hours_type,
            hours,
        } = this.state;

        // current user must be the timesheet handler
        let handler_id = roleInfo.identity.id;
        let handler_team_id = "";

        // let handler_department_id = null;
        if (radioValue === NOMATTER) {
            handler_team_id = this.levelChoose.getData().handler_team_id;
            if (handler_team_id === "") {
                this.showToast("Please choose a team", "warning")
                return;
            }
        } else {
            if (matter_id === "") {
                this.showToast("Please choose an existing matter", "warning")
                return;
            }
            const matterObj = getObjByName(mattersData, "id", matter_id);
            const handlers = matterObj.handler;
            let attorneyObj = {};
            for (const obj of handlers) {
                if (obj.is_origin_attorney) {
                    attorneyObj = obj;
                }
            }

            // handler_id = attorneyObj.user ? attorneyObj.user.id : "";
            handler_team_id = attorneyObj.team ? attorneyObj.team.id : "";
            // handler_department_id = attorneyObj.team ? attorneyObj.team.dept_info.id : "";
        }

        const has_matter = radioValue === HASMATTER,
            obj = {
                note,
                date: (Date.parse(new Date(date)) / 1000) + "",
                hours: parseInt(hours * 3600),
                has_matter: has_matter,
                hours_type,
                matter_id,
                handler_id,
                handler_team_id,
                // handler_department_id
            };
        if (!matter_id && has_matter) return;
        // if (radioValue === NEEDCLIENT) {
        //     obj[matter_id] = matter_id
        // }
        this.props.handleTimer(obj);
    }

    handleCloseDialog() {
        this.closeDialog();
    }

    handleCancel() {
        this.closeDialog();
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleAlertYes() {
        const { count } = this.state;
        const hours = Math.floor(((count + 35) / 3600) * 100) / 100;
        this.setState(() => ({
            showAlert: false,
            hours
        }));
    }

    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
        }));
    }

    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }

    handleCreate(obj) {
        this.createMatters(obj);
    }

    startTimer() {
        let timeS = 0;
        let timeM = 0;
        let timeH = 0;
        const { count } = this.state;
        let countCopy = count;
        this.timer = setInterval(() => {
            countCopy++;
            // 需要改变页面上时分秒的值
            timeS = this.showNum(countCopy % 60);
            timeM = this.showNum(parseInt(countCopy / 60) % 60);
            timeH = this.showNum(parseInt(countCopy / 60 / 60));
            this.setState(() => ({
                count: countCopy,
                timeS,
                timeM,
                timeH,
            }));
        }, 1000);
    }

    showNum(num) {
        if (num < 10) {
            return '0' + num
        }
        return num
    }

    closeDialog() {
        this.setState(() => ({
            open: false,
        }));
    }

    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
        }));
    }

    getTeamName(arr, name) {
        if (arr) {
            if (arr.length > 0) {
                if (name === "team") {
                    return arr[0].team.name;
                } else if (name === "user") {
                    return arr[0].user.username;
                }
            }
        }
        return "";
    }

    //-------------request------------
    getMatters() {
        let params = {
            // number: obj.name,
            // name: obj.note,
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + "" + roleStr() + "/matters", { params }).then((res) => {
            const mattersData = res.data.data;
            this.setState(() => ({
                mattersData
            }))
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    createMatters(obj) {
        let params = {
            case_id: obj.case_id,
            number: obj.number,
            name: obj.name,
            note: obj.note,
            handlers: obj.handlers.addMembers
        }

        instance.post(BASE_URL + "" + roleStr() + "/matters", params).then((res) => {
            this.showToast("Added successfully", "success");
            // this.getMatters();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default Timer;